import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const CustomFieldsPage = lazy(() => import('./pages/CustomFieldsPage'));

export const CustomFieldsRoutes: RouteObject = {
  path: 'custom-fields',
  children: [
    { path: '', element: <CustomFieldsPage />, handle: { crumb: 'Custom Fields' } },
  ],
};
